import { queryOptions, useQuery } from '@tanstack/react-query';

import { ApiResponse, QueryOptions } from '@cast/shared-types';

import { apiClient } from '@cast/infrastructure-api';

const CLUSTER_RELIABILITY_METRICS_QUERY_KEY = 'cluster-reliability-metrics';

const apiFn = apiClient.costReport.getClusterReliabilityMetrics;

export type ClusterReliabilityMetricsQueryData = ApiResponse<typeof apiFn>;

const getClusterReliabilityMetricsQueryKey = (
  params?: Parameters<typeof apiFn>[0]
) => [CLUSTER_RELIABILITY_METRICS_QUERY_KEY, ...(params ? [params] : [])];

export const getClusterReliabilityMetricsQueryOptions = <
  TSelected = ClusterReliabilityMetricsQueryData
>(
  params: Parameters<typeof apiFn>[0],
  options?: QueryOptions<ClusterReliabilityMetricsQueryData, TSelected>
) =>
  queryOptions({
    queryKey: getClusterReliabilityMetricsQueryKey(params),
    queryFn: async () => {
      const { data } = await apiFn(params);
      return data;
    },
    ...options,
  });

export const useClusterReliabilityMetricsQuery = <
  TSelected = ClusterReliabilityMetricsQueryData
>(
  params: Parameters<typeof apiFn>[0],
  options?: QueryOptions<ClusterReliabilityMetricsQueryData, TSelected>
) => {
  const { data, ...rest } = useQuery(
    getClusterReliabilityMetricsQueryOptions(params, options)
  );

  return { data, ...rest };
};
